import React from 'react';
import { DataProvider } from './context/DataContext';
import { ReactNotifications } from 'react-notifications-component';
import './App.css';
import 'react-notifications-component/dist/theme.css';
import Baseroute from './Baseroute';
import { ScrollToTop } from './components';
// import ClutchWidget from './components/ClutchWidget/ClutchWidget';
// import {BrowserRouter as Router,  Route, Routes } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <ReactNotifications />
      <DataProvider>
        <ScrollToTop />
        <Baseroute />
        {/* <ClutchWidget /> */}
      </DataProvider>
      {/* <Routes>
        <Route path='/under-maintenance' element={<Undermaintenance />} />
        <Route path='/sesstion-timeout' element={<Sesstiontimeout />} />
        <Route path='404' element={<Pagenotfound />} />
      </Routes> */}
    </div>
  );
}

export default App;

// "start": "NODE_ENV=development node scripts/start.js",
//   "start-prod": "NODE_ENV=production node scripts/start.js",
//     "build-dev": "NODE_ENV=development node scripts/build.js",
//       "build-prod": "NODE_ENV=production node scripts/build.js",

// import React from 'react';
// import { DataProvider } from './context/DataContext';
// import { ReactNotifications } from 'react-notifications-component';
// import './App.css';
// import 'react-notifications-component/dist/theme.css';
// import Baseroute from './Baseroute';
// import { ScrollToTop } from './components';
// import Aibaseroute from './Aibaseroute';
// import { VideoLayout } from './pages';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { Button } from '@mui/material';
// // import ClutchWidget from './components/ClutchWidget/ClutchWidget';
// // import {BrowserRouter as Router,  Route, Routes } from 'react-router-dom';

// function App() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const path = location.pathname;
//   let selectedRoute = '';
//   if (path !== '/' && !path.startsWith('/ai')) {
//     selectedRoute = 'service';
//   } else if (path.startsWith('/ai')) {
//     selectedRoute = 'ai';
//   }

//   const handleServiceSelect = () => {
//     navigate('/home');
//   };

//   const handleAISelect = () => {
//     navigate('/ai');
//   };

//   const handleBackToVideoLayout = () => {
//     navigate('/');
//   };

//   return (
//     <>
//       <div className="App">
//         <ReactNotifications />
//         <DataProvider>
//           <ScrollToTop />
//           {selectedRoute !== '' && (
//             <Button
//               onClick={() => handleBackToVideoLayout()}
//               sx={{
//                 position: 'fixed',
//                 bottom: '20px',
//                 right: '20px',
//                 zIndex: 1000,
//                 padding: '10px 15px',
//                 backgroundColor: '#2196F3',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '8px',
//                 cursor: 'pointer',
//                 fontWeight: 'bold',
//                 boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
//                 transition: 'all 0.3s ease'
//               }}
//               onMouseOver={(e) => {
//                 e.target.style.backgroundColor = '#1976D2';
//                 e.target.style.transform = 'scale(1.05)';
//               }}
//               onMouseOut={(e) => {
//                 e.target.style.backgroundColor = '#2196F3';
//                 e.target.style.transform = 'scale(1)';
//               }}
//             >
//               Return to Selection
//             </Button>
//           )}
//           {selectedRoute === 'ai' ? (
//             <Aibaseroute />
//           ) : selectedRoute === 'service' ? (
//             <Baseroute />
//           ) : (
//             <VideoLayout
//               onAiSelect={handleAISelect}
//               onServiceSelect={handleServiceSelect}
//             />
//           )}
//           {/* <ClutchWidget /> */}
//         </DataProvider>
//         {/* <Routes>
//         <Route path='/under-maintenance' element={<Undermaintenance />} />
//         <Route path='/sesstion-timeout' element={<Sesstiontimeout />} />
//         <Route path='404' element={<Pagenotfound />} />
//       </Routes> */}
//       </div>
//     </>
//   );
// }

// export default App;

// // "start": "NODE_ENV=development node scripts/start.js",
// //   "start-prod": "NODE_ENV=production node scripts/start.js",
// //     "build-dev": "NODE_ENV=development node scripts/build.js",
// //       "build-prod": "NODE_ENV=production node scripts/build.js",
